import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Container from './Container';

export default function App() {
	return (
			<Router basename={`${import.meta.env.VITE_ROOT_PATH}`}>
				<Container />
			</Router>
	);
}
